import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface UniformMaintenanceModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UniformMaintenanceModal: React.FC<UniformMaintenanceModalProps> = ({
  isOpen,
  onClose
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
            onClick={onClose}
          >
            {/* Modal */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Content */}
              <div className="px-6 py-8">
                <div className="text-center">
                  {/* Message */}
                  <p className="text-black text-lg mb-6">
                    Site en maintenance. Revenez plus tard.
                  </p>
                </div>
              </div>

              {/* Footer */}
              <div className="px-6 pb-6 flex justify-center">
                <button
                  onClick={onClose}
                  className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-3 rounded-lg font-medium transition-colors duration-200"
                >
                  Compris
                </button>
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default UniformMaintenanceModal;